import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import VueI18n from '../../helpers/i18n';

import {Shard, Company, Badge, Product} from '@/store/modules/lib'
import value from '*.json';

export interface State {
  shards: any[]
  FilterShards: any[any]
  guestshards: Shard[]
  customContacts: Shard[]
  loadStatus: string,
  loadFromServer: boolean,
  countFiltersShards: number
}

const defaultState: State = {
  shards: [],
  FilterShards: [
    {type: 'typeFilterItem', value: [{id: 'all', text: VueI18n.t('newShardList.filter.filter_data.items.all')}]},
    {type: 'typeFilterFio', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_fio.items.all')}]},
    {type: 'typeFilterPending', value:false},
    {type: 'typeDatePicker', value:[]},
    {type: 'typeTag', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_tag.items.all')}]},
    {type: 'typeSurvey', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_survey.items.all')}]},
    {type: 'typeNotes', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_notes.items.all')}]},
    {type: 'typeDataSource', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_data_source.items.all')}]},
  ],
  guestshards: [],
  customContacts: [],
  loadStatus: '',
  loadFromServer: false,
  countFiltersShards: 0
}

const getters = {
  GetFilterShards:(state:State)=>state.FilterShards,
  GetCountFiltersShards(state: State) {
    let count:number = 0
    if (state.FilterShards[0].value.filter((el:any)=>{return el.id != 'all'}).length > 0) {count++}
    if (state.FilterShards[1].value.filter((el:any)=>{return el.id != 'all'}).length > 0) {count++}
    if (state.FilterShards[2].value !== false) {count++}
    if (state.FilterShards[3].value.length>0) {count++}
    if (state.FilterShards[4].value.length>0) {count++}

    return count

  },
  GetShards: (state: State) => {
    let result  = state.shards
    if (state.FilterShards.filter((ele:any) => {
      return ele.value != null
    }).length > 0) {

      //тут логика фильтрации

      state.FilterShards.forEach((ele:any)=>{
        switch (ele.type) {
          case 'typeFilterItem':
            if(ele.value.length){
              if(ele.value[0].id != "all" ){
                let idArr = ele.value.map((element:any) => element.id)
                result=result.filter((elem) => {
                  return idArr.includes(elem.target_type)
                })
              }
            }
            break;
          case 'typeFilterFio':
            if(ele.value.length){
              if(ele.value[0].id != "all" ){
                let idArr = ele.value.map((element:any) => element.id)
                result=result.filter((elem) => {
                  return idArr.includes(elem.metadata._author)
                })
              }
            }
            break;
          case 'typeFilterPending':
            if(ele.value){
              result=result.filter((elem) => {
                if(elem.target_type === 'pending_badge' || elem.target_type === 'pending_product' || elem.target_type === 'pending_stand' )
                {
                  return false
                }
                return true

              })
            }
              break;

          case 'typeDatePicker':
            if(ele.value.length>0){
              result=result.filter((elem) => {
                if(state.FilterShards[3].value.length === 1){
                  if(
                    new Date(state.FilterShards[3].value[0]).getDate() ===
                    new Date(elem.metadata.createAt*1000).getDate()
                  )
                  {
                    return true
                  }

                  return false
                }
                if(state.FilterShards[3].value.length > 1){
                  if
                  (
                    new Date(state.FilterShards[3].value[0]).getDate() <= new Date(elem.metadata.createAt*1000).getDate()
                    &&
                    new Date(elem.metadata.createAt*1000).getDate() <= new Date(state.FilterShards[3].value[1]).getDate()
                  )
                  {
                    return true
                  }

                  return false
                }

                return false
              })
            }
            break;
            case 'typeTag':
              if(ele.value.length){
                if(ele.value[0].id != "all" ){

                }
              }
              break;
            case 'typeSurvey':
              if(ele.value.length){
                if(ele.value[0].id != "all" ){

                }
              }
              break;
            case 'typeNotes':
              if(ele.value.length){
                if(ele.value[0].id != "all" ){

                }
              }
              break;
            case 'typeDataSource':
              if(ele.value.length){
                if(ele.value[0].id != "all" ){

                }
              }
              break;
        }
      })
    }
    return result
  },
  GetLoadFromServer: (state: State) => state.loadFromServer
}

const mutations: MutationTree<State> = {

  setFilterShards(state: State, payload: any) {
    state.FilterShards.filter((ele:any) => {
      return ele.type == payload.type
    })[0].value= [] = payload.value

  },
  clearFilterShards(state: State,payload:boolean=true) {

   state.FilterShards.splice(0,state.FilterShards.length)
    if(payload){
      state.FilterShards =[
        {type: 'typeFilterItem', value: []},
        {type: 'typeFilterFio', value:[]},
        {type: 'typeFilterPending', value:false},
        {type: 'typeDatePicker', value:[]},
        {type: 'typeTag', value:[]},
        {type: 'typeSurvey', value:[]},
        {type: 'typeNotes', value:[]},
        {type: 'typeDataSource', value:[]},
      ]
    } else {
      state.FilterShards =[
        {type: 'typeFilterItem', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_data.items.all')}]},
        {type: 'typeFilterFio', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_fio.items.all')}]},
        {type: 'typeFilterPending', value:false},
        {type: 'typeDatePicker', value:[]},
        {type: 'typeTag', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_tag.items.all')}]},
        {type: 'typeSurvey', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_survey.items.all')}]},
        {type: 'typeNotes', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_notes.items.all')}]},
        {type: 'typeDataSource', value:[{id: 'all', text: VueI18n.t('newShardList.filter.filter_data_source.items.all')}]},
      ]
    }


  },
  setLoadFromServer(state: State, payload: boolean) {
    state.loadFromServer = payload
  },
  setShards(state: State, payload: Shard[]) {
    state.shards = payload
  },
  loading(state: State) {
    state.loadStatus = 'loading'
  },

  setupShards(state: State, shards: Shard[]) {
    state.loadStatus = 'shrads success'
    state.shards = shards
  },

  setupGuestShards(state: State, shards: Shard[]) {
    state.loadStatus = 'guest shrads success'
    state.shards = shards
  },

  setupCustomContacts(state: State, shards: Shard[]) {
    state.loadStatus = 'custom contacts success'
    state.customContacts = shards
  },

  error(state: State) {
    state.loadStatus = 'error'
    state.shards = []
  }
}

const actions: ActionTree<State, RootState> = {
  load({commit}, {exhibitor}) {
    return new Promise((resolve, reject) => {
      commit('loading');

      let shards: Shard[] = [];
      let guestShards: Shard[] = [];

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "query{
              Shards(_exhibitor:\\"${exhibitor}\\") {
                count
                time
                values {
                  _badge
                  _company
                  _event
                  _id
                  _show
                  standTitle
                  surveyData {
                    _survey
                    answers {
                      id
                      sense
                      order
                      value
                    }
                  }
                  _target
                  target_type
                  timestamp
                }
              }
            }",
            "variables": {}
          }
        `
      })
        .then((resp_s: any) => {

          if (resp_s.data.status == 'ok') {

            shards = Object.values(resp_s.data.data.Shards.values
              .reduce((obj: any, item: any) => {
                if (!obj[item._target])
                  obj[item._target] = item;
                else {
                  if (obj[item._target].timestamp < item.timestamp)
                    obj[item._target] = item;
                }
                return obj;
              }, {}));

            Vue.axios({
              url: '/query',
              method: 'POST',
              data: `
                {
                  "query": "query{
                    GuestShards(_exhibitor:\\"${exhibitor}\\"){
                      count
                      time
                      values {
                        _badge
                        _company
                        _event
                        _id
                        _show
                        standTitle
                        _target
                        target_type
                        timestamp
                      }
                    }
                  }",
                  "variables": {}
                }
              `
            })
              .then((resp_gs: any) => {

                if (resp_gs.data.status == 'ok') {

                  guestShards = Object.values(resp_gs.data.data.GuestShards.values
                    .reduce((obj: any, item: any) => {
                      if (!obj[item._target])
                        obj[item._target] = item;
                      else {
                        if (obj[item._target].timestamp < item.timestamp)
                          obj[item._target] = item;
                      }
                      return obj;
                    }, {}));

                  let commonShards = [...shards, ...guestShards]

                  let entities = commonShards.reduce((ids: any, shard: Shard) => {
                    if ((shard.target_type === 'company') && (!ids.companyIds.includes(`\\"${shard._target}\\"`)))
                      ids.companyIds.push(`\\"${shard._target}\\"`)

                    if (shard._target === null) {
                    } else if ((shard.target_type == 'company') && (!ids.companyIds.includes(`\\"${shard._target}\\"`)))
                      ids.companyIds.push(`\\"${shard._target}\\"`);

                    else if ((shard.target_type == 'custom_contact') && (!ids.badgeIds.includes(`\\"${shard._target}\\"`)))
                      ids.customContactIds.push(`\\"${shard._target}\\"`);

                    else if ((shard.target_type == 'badge') && (!ids.badgeIds.includes(`\\"${shard._target}\\"`)))
                      ids.badgeIds.push(`\\"${shard._target}\\"`);

                    else if ((shard.target_type === 'product') && (!ids.productIds.includes(`\\"${shard._target}\\"`)))
                      ids.productIds.push(`\\"${shard._target}\\"`)

                    if ((shard._company !== null) && (shard._company !== '') && (!ids.companyIds.includes(`\\"${shard._company}\\"`)))
                      ids.companyIds.push(`\\"${shard._company}\\"`)

                    if ((shard._badge !== '') && (!ids.badgeIds.includes(`\\"${shard._badge}\\"`)))
                      ids.badgeIds.push(`\\"${shard._badge}\\"`)

                    return ids

                  }, {companyIds: [], badgeIds: [], customContactIds: [], productIds: []});

                  let companies: Company[] = []
                  let badges: Badge[] = []
                  let products: Product[] = []

                  // Компании
                  Vue.axios({
                    url: '/query',
                    method: 'POST',
                    data: `
                      {
                        "query": "query{Companies(ids:[${entities.companyIds}]){ count values { contacts { id type title value order } description _id locations { id title postcode _country region city address order } photo promo { id type value order } _show standTitle title thematics { id title child { title } } } }}",
                        "variables": {}
                      }
                    `
                  })
                    .then((resp: any) => {

                      if (resp.data.status == 'ok') {

                        companies = resp.data.data.Companies.values;

                        // Бейджи
                        Vue.axios({
                          url: '/query',
                          method: 'POST',
                          data: `
                            {
                              "query": "query{
                                Badges(ids:[${entities.badgeIds}]){
                                  count
                                  values {
                                    about
                                    barcode
                                    _company
                                    companyTitle
                                    contacts {
                                      id
                                      type
                                      title
                                      value
                                      order
                                    }
                                    _show
                                    _id
                                    locations {
                                      id
                                      title
                                      postcode
                                      _country
                                      region
                                      city
                                      address
                                      order
                                    }
                                    name {
                                      first
                                      middle
                                      last
                                      gender
                                    }
                                    photo
                                    position
                                    promo {
                                      id
                                      type
                                      value
                                      order
                                    }
                                    role
                                    settings {
                                      value
                                    }
                                    standTitle
                                    thematics {
                                      id
                                      title
                                      child {
                                        title
                                      }
                                    }
                                    _user
                                  }
                                }
                              }",
                              "variables": {}
                            }
                          `
                        })
                          .then((resp: any) => {

                            if (resp.data.status == 'ok') {

                              badges = resp.data.data.Badges.values;

                              // CustomContact
                              Vue.axios({
                                url: '/query',
                                method: 'POST',
                                data: `
                            {
                              "query": "query{
                                CustomContacts(ids:[${entities.customContactIds}]){
                                  count
                                  values {
                                    about
                                    barcode
                                    _company
                                    companyTitle
                                    contacts {
                                      id
                                      type
                                      title
                                      value
                                      order
                                    }
                                    _show
                                    _id
                                    locations {
                                      id
                                      title
                                      postcode
                                      _country
                                      region
                                      city
                                      address
                                      order
                                    }
                                    name {
                                      first
                                      middle
                                      last
                                      gender
                                    }
                                    photo
                                    position
                                    promo {
                                      id
                                      type
                                      value
                                      order
                                    }
                                    role
                                    settings {
                                      value
                                    }
                                    standTitle
                                    thematics {
                                      id
                                      title
                                      child {
                                        title
                                      }
                                    }
                                    _user
                                  }
                                }
                              }",
                              "variables": {}
                            }
                          `
                              })
                                .then((resp: any) => {

                                  if (resp.data.status == 'ok') {

                                    badges = badges.concat(resp.data.data.CustomContacts.values);

                                    commit('setupCustomContacts', resp.data.data.CustomContacts.values);

                                    // Продукты
                                    Vue.axios({
                                      url: '/query',
                                      method: 'POST',
                                      data: `
                                        {
                                          "query": "query{Products(ids:[${entities.productIds}]){ count values { characters { title description value } _company description _event _id photo promo { id type value order } _show standTitle thematic { id title child { title } } title vendorCode } }}",
                                          "variables": {}
                                        }
                                      `
                                    })
                                      .then((resp: any) => {

                                        if (resp.data.status == 'ok') {

                                          products = resp.data.data.Products.values;

                                          let cs: any[] = [];
                                          let bs: any[] = [];
                                          let ps: any[] = [];

                                          shards = shards.map((shard: Shard) => {

                                            if (shard.target_type == 'company') {
                                              cs = companies.filter((c: any) => c._id == shard._target);
                                              shard.target = cs.length > 0 ? cs[0] : null
                                            } else if (shard.target_type == 'badge') {
                                              bs = badges.filter((b: Badge) => b._id == shard._target)
                                              shard.target = bs.length > 0 ? bs[0] : null
                                            } else if (shard.target_type == 'product') {
                                              ps = products.filter((p: Product) => p._id == shard._target)
                                              shard.target = ps.length > 0 ? ps[0] : null
                                            }

                                            if (shard._company) {
                                              cs = companies.filter((c: any) => c._id == shard._company)
                                              shard.company = cs.length > 0 ? cs[0] : null
                                            }

                                            if (shard._badge) {
                                              bs = badges.filter((b: Badge) => b._id == shard._badge)
                                              shard.badge = bs.length > 0 ? bs[0] : null
                                            }

                                            return shard
                                          })

                                          guestShards = guestShards.map((shard: Shard) => {
                                            bs = badges.filter((b: Badge) => b._id == shard._target)
                                            shard.target = bs.length > 0 ? bs[0] : null

                                            if (shard._company) {
                                              cs = companies.filter((c: any) => c._id == shard._company)
                                              shard.company = cs.length > 0 ? cs[0] : null
                                            }

                                            return shard
                                          })

                                          commit('setupShards', shards)
                                          commit('setupGuestShards', guestShards)

                                          resolve({shards, guestShards})
                                        } else {
                                          reject(resp)
                                        }
                                      })
                                      .catch((err: any) => {
                                        commit('error')
                                        reject(err)
                                      })
                                  } else {
                                    reject(resp)
                                  }
                                })
                                .catch((err: any) => {
                                  commit('error')
                                  reject(err)
                                })
                            } else {
                              reject(resp)
                            }
                          })
                          .catch((err: any) => {
                            commit('error')
                            reject(err)
                          })
                      } else {
                        reject(resp)
                      }
                    })
                    .catch((err: any) => {
                      commit('error')
                      reject(err)
                    })
                } else {
                  reject(resp_gs)
                }
              })
              .catch((err: any) => {
                commit('error')
                reject(err)
              })
          } else {
            reject(resp_s)
          }
        })
        .catch((err: any) => {
          commit('error')
          reject(err)
        })
    })
  },

  async loadPendingShards({commit}, {eventId, badgeIds, productIds}): Promise<any> {
    try {
      const response = await Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "query{
              PendingShards(_event: \\"${eventId}\\", badges: [${badgeIds}], products: [${productIds}]) {
                badges {
                  _id
                  login
                  plan
                  barcode
                  position
                  name {
                      first
                      middle
                      last
                      gender
                      postfix
                      prefix

                  }
                  companyTitle
                  _company
                  about
                  contacts {
                      id
                      order
                      title
                      type
                      value
                  }
                  locations {
                      id
                      title
                      postcode
                      _country
                      region
                      city
                      address
                      order
                      mapLatitude
                      mapLongitude
                  }
                  standTitle
                  pincode
                  photo
                  role
                  _show
                  promo {
                      id
                      order
                      type
                      value
                      title
                  }
                  thematics {
                      id
                      title
                  }
                }
                products {
                  _id
                  description
                  title
                  _company
                  vendorCode
                  _show
                  _event
                  standTitle
                  photo
                  thematic {
                      id
                      title
                  }
                  promo {
                      id
                      order
                      type
                      value
                      title
                  }
                  characters {
                      title
                      description
                      value
                  }
                }
              }
            }"
          }
        `
      })

      return response.data.data.PendingShards
    } catch (error) {
      console.error('PendingShards Store Action Error:::', error)
    }
  },

  async saveShard({commit}, shards: { _id: string, _target?: string, target_type: string }[]): Promise<any> {
    const shardsData: string = shards.reduce((prev: string, cur) => {
      if (cur._target)
        return prev + `{
          _id: \\"${cur._id}\\",
          _target: \\"${cur._target}\\",
          target_type: \\"${cur.target_type}\\"
        }`

      return prev + `{
        _id: \\"${cur._id}\\",
        target_type: \\"${cur.target_type}\\"
      }`
    }, '')

    try {
      const response = await Vue.axios({
        url: '/query',
        method: 'POST',
        data: `{
          "query": "mutation{
            ShardsData(shards: [${shardsData}]) {
              results {
                _id
                status
              }
            }
          }"
        }`
      })

      return response
    } catch (error) {
      console.error('Save Shard Store Action Error::', error)
    }
  },
  async actionGetShardsFromServer({commit}, payload: string) {
    commit('setLoadFromServer', false)
    const shardsResponse = await Vue.axios({
      url: `/web/shards/${payload}`,
      method: 'GET',
    })
    if (shardsResponse.data.code == '01') {
      commit('setShards', shardsResponse.data.data)
      commit('setLoadFromServer', true)
      return true
    }
    commit('setLoadFromServer', true)
    return false
  }


}

export default {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters
}
